import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetCajaPrimaria } from '@/shared/actions/erp';
import { SaveCajaPrimariaComponent } from '../../shared/components/SaveCajaPrimariaComponent';
import { LoaderComponent } from '@/shared/components/ui';

export interface UpdateCajaPrimariaPageProps { }

const UpdateCajaPrimariaPage: React.FC<UpdateCajaPrimariaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_cajaprimaria);
  const returnUrlOLTsPage = ROUTER_PATHS.configuracionRED.cajaPrimariaNav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetCajaPrimaria(id!);

  if (isLoading || isRefetching) return null;

  if (!data?.data?.id_caja_primaria)
    return <Navigate to={returnUrlOLTsPage} />;

  if (isLoading) 
    return <LoaderComponent />

  return <SaveCajaPrimariaComponent title={`Editar Manga - ${data?.data?.nombre || "..."}`} cajaPrimaria={data.data} />;
};

export default UpdateCajaPrimariaPage;
